var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDeleteFile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 21,
    viewBox: "0 0 18 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.00033 7.83333C6.36852 7.83333 6.66699 8.13181 6.66699 8.5V16.5C6.66699 16.8682 6.36852 17.1667 6.00033 17.1667C5.63214 17.1667 5.33366 16.8682 5.33366 16.5V8.5C5.33366 8.13181 5.63214 7.83333 6.00033 7.83333Z",
    fill: "#2362A2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.33366 7.83333C9.70185 7.83333 10.0003 8.13181 10.0003 8.5V16.5C10.0003 16.8682 9.70185 17.1667 9.33366 17.1667C8.96547 17.1667 8.66699 16.8682 8.66699 16.5V8.5C8.66699 8.13181 8.96547 7.83333 9.33366 7.83333Z",
    fill: "#2362A2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3337 8.5C13.3337 8.13181 13.0352 7.83333 12.667 7.83333C12.2988 7.83333 12.0003 8.13181 12.0003 8.5V16.5C12.0003 16.8682 12.2988 17.1667 12.667 17.1667C13.0352 17.1667 13.3337 16.8682 13.3337 16.5V8.5Z",
    fill: "#2362A2"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.0003 4.5C18.0003 5.23638 17.4034 5.83333 16.667 5.83333H16.0003V17.8333C16.0003 19.3061 14.8064 20.5 13.3337 20.5H5.33366C3.8609 20.5 2.66699 19.3061 2.66699 17.8333V5.83333H2.00033C1.26395 5.83333 0.666992 5.23638 0.666992 4.5V3.16667C0.666992 2.43029 1.26395 1.83333 2.00033 1.83333H6.66699C6.66699 1.09695 7.26395 0.5 8.00033 0.5H10.667C11.4034 0.5 12.0003 1.09695 12.0003 1.83333H16.667C17.4034 1.83333 18.0003 2.43029 18.0003 3.16667V4.5ZM4.1577 5.83333L4.00033 5.91202V17.8333C4.00033 18.5697 4.59728 19.1667 5.33366 19.1667H13.3337C14.07 19.1667 14.667 18.5697 14.667 17.8333V5.91202L14.5096 5.83333H4.1577ZM2.00033 4.5V3.16667H16.667V4.5H2.00033Z",
    fill: "#2362A2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteFile);
export default __webpack_public_path__ + "static/media/delete_file.40957e69a80793658ee8b74f1dd2b349.svg";
export { ForwardRef as ReactComponent };